module.exports = __webpack_public_path__ + "img/emoji_79.bba98270.png";